import React, { Component } from 'react';
import styles from './styles.scss';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import WModal from '../../components/WModal/WModal';
import WWebView from '../../helpers/wwebview';
import WJSON from '../../helpers/json';
// import UserInfo from '../../helpers/userinfo';

import {
  isIOS,
} from "react-device-detect";

class Drawing extends Component 
{
  constructor(props){
    super(props);
    this.state = {
      show_spinner:true,
      message:null,
      no_data:false,
      drawing_list:[],
    };
  }
  componentDidMount(){
    this.pullData()
  }
  pullData(){

    this.setState({ show_spinner: true });

    http.get(
      CONFIG.API_HOST + 'api/v1.3/drawing',
      { }, 
      (state, res) => {
        
        this.setState({ show_spinner: false });
        
        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (res.code !== 200) { return this.setState({ message: res.reason }); }

        const { drawing_list = [] }= res.data;

        this.setState({
          no_data: drawing_list.length === 0,
          drawing_list: drawing_list
        })
        
      }
    )
  }
  getFile(type = 'email'){

    const {drawing_list=[]} = this.state

    var drawing_ids = []
    drawing_list.forEach((item, idx) => {
      
      if (item.checked != true) { return }

      drawing_ids.push(item.id)  

      return item.id;
    })

    console.log(drawing_ids)

    if (drawing_ids.length == 0)
    {
      return WModal.show('請選擇要下載的圖檔');
    }
    this.setState({ show_spinner: true });
    http.post(CONFIG.API_HOST + 'api/v1.3/drawing/download', 
      {
        action      : "download",
        drawing_ids :drawing_ids
      }
      , 
      (state, res) => {

        this.setState({ show_spinner: false });

        const {code=100, reason='發生錯誤', data={} } = res;

        if (state === false) { return  WModal.show('發生錯誤'); }

        if (code !== 200)    { return WModal.show(reason); }

        const { download_url = null } = data;

        if (download_url != null)
        {
          WWebView.openURL(download_url);
        }
        
    })
  }
  render()
  {

    var { drawing_list = [] }= this.state
    if (Array.isArray(drawing_list) == false) drawing_list = [];
    return (
      <div className={styles.page_container}>
        
        { (this.state.no_data || this.state.message) && 
          <WMask  title={ this.state.message ? this.state.message : ''}>
            { this.state.no_data &&
              <div>
                <h1>目前暫無資料</h1>
              </div>
            }
          </WMask>
        }
        { drawing_list.length > 0 &&
          <div className={'container'}>
            <h1>請選擇圖檔</h1>
            <form onSubmit={(e) => {e.preventDefault();}} >
              <div>
                <div className="form-group">
                  { drawing_list.map((item, key)=>
                      <div key={key} className={[styles.checkbox, "checkbox"].join(' ')}>
                        <label>
                          <input type="checkbox" onChange={(e) =>{ item.checked = e.target.checked; console.log('aaa',e.target, e.target.checked == true)}}/>
                          <span className={styles.checkmark}/>
                          {item.name}
                        </label>
                      </div>
                    )
                  }
                </div>
                <hr/>
                { drawing_list.length > 0 && isIOS && 
                  <h4>支援 iOS 10 以上版本</h4>
                }
              </div>
              { this.state.download_url && 
                <div className={styles.anchor}>
                  <div className="container">
                    <button type="button" className="btn btn-primary" 
                      onClick={ e => { WWebView.openURL(this.state.download_url); }}
                      >
                      <span name='download'/>
                      開啟下載連結
                    </button>
                  </div>
                </div>
              }
              { drawing_list.length > 0 &&
                <div className={styles.anchor}>
                  <div className="container_btn">
                    <button type="button"
                            className="btn btn-primary" 
                            onClick={() => {

                              const {drawing_list=[]} = this.state

                              var drawing_ids = []

                              drawing_list.forEach((item, idx) => {
                                
                                if (item.checked != true) { return }

                                drawing_ids.push(item.id)  

                                return item.id;
                              })

                              if (drawing_ids.length == 0)
                              {
                                return WModal.show('請選擇要下載的圖檔');
                              }
                              
                              this.props.history.push('/drawing/sent?drawing_ids='+WJSON.encode(drawing_ids))

                            }} >
                      <span name='mail'/>
                      寄送Email
                    </button>
                    <button  type="button" className="btn btn-primary" onClick={() => this.getFile()} >
                      <span name='download'/>
                      下載圖檔
                    </button>
                  </div>
                </div>
              }
              
            </form>
          </div>
        }
        
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }
      </div>
    );
  }
}

export default Drawing;


// WEBPACK FOOTER //
// ./src/views/Drawing/Drawing.js